import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54238c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ForgotPassword",
  "data-cy": "ForgotPassword"
}
const _hoisted_2 = { class: "ForgotPasswordTitle" }
const _hoisted_3 = { class: "ForgotPasswordDescription" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailInput = _resolveComponent("EmailInput")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.text.header), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text.message), 1 /* TEXT */),
    (!_ctx.emailSent)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestReset && _ctx.requestReset(...args)), ["prevent"])),
          class: "FgForm"
        }, [
          _createVNode(_component_EmailInput),
          _createVNode(_component_SubmitButton, {
            type: _ctx.submitType,
            onSubmitButtonClicked: _ctx.requestReset
          }, null, 8 /* PROPS */, ["type", "onSubmitButtonClicked"]),
          (_ctx.store.getters.errorMessage().message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.store.getters.errorMessage().message), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 32 /* HYDRATE_EVENTS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("a", {
      href: "#",
      class: "BackToLogin",
      "data-cy": "BackToLogin",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backToLogin && _ctx.backToLogin(...args)), ["prevent"]))
    }, "Back to Log in")
  ]))
}